import Fetch from './index'

export const getRitaInstance = async ({ assistantID }) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/rita-instance/?assistantID=' + assistantID)
}

export const createRitaInstance = async (body) => {
  const data = new FormData()
  for (const key in body) {
    data.set(key, body[key])
  }

  return Fetch('/rita-instance/', {
    method: 'POST',
    body: data,
  })
}

export const deleteRitaInstance = async (id) => {
  return Fetch('/rita-instance/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const updateRitaInstance = async (id, body) => {
  delete body['createdAt']
  delete body['updatedAt']
  delete body['deletedAt']
  delete body['id']

  const data = new FormData()
  for (const key in body) {
    data.set(key, body[key])
  }

  return Fetch('/rita-instance/' + id, {
    method: 'PUT',
    body: data,
  })
}

export const getRitaIdentityKeys = async (id) => {
  return Fetch(`/rita-instance/${id}/identity-keys`)
}

export const createRitaIdentityKey = async (id, body) => {
  return Fetch(`/rita-instance/${id}/identity-keys`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
}

export const revokeRitaIdentityKey = async (id, keyID) => {
  return Fetch(`/rita-instance/${id}/identity-keys/${keyID}`, {
    method: 'DELETE',
  })
}

export const rotateRitaIdentityKey = async (id, keyID) => {
  return Fetch(`/rita-instance/${id}/identity-keys/${keyID}/rotate`, {
    method: 'POST',
  })
}
